<template>
	<div class="container pb_0">
		<div class="main">
			<p class="text_t type1">
				{{ $t('rtr_personal-asset-sale.title1') }}
			</p>
			<p class="text_n">
				{{ $t('rtr_personal-asset-sale.text1') }}<br />
				{{ $t('rtr_personal-asset-sale.text2') }}
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.signup') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box mb_16">
					<div class="bg_text_area center">
						<p class="text_t fc_white tac">
							{{ $t('rtr_personal-asset-sale.title2') }}<br />
							{{ $t('rtr_personal-asset-sale.title3') }}
						</p>
						<p class="text_n fc_white tac">
							{{ $t('rtr_personal-asset-sale.text3')
							}}{{ $t('rtr_personal-asset-sale.text4') }}<br />
							{{ $t('rtr_personal-asset-sale.text5') }}
						</p>
					</div>
				</div>

				<div class="bg_box bg_white">
					<div class="bg_text_area right tac">
						<p class="text_t mb_30">
							{{ $t('rtr_personal-asset-sale.title4') }}<br />
							{{ $t('rtr_personal-asset-sale.title5') }}
						</p>
						<p class="text_n">
							{{ $t('rtr_personal-asset-sale.text6') }}<br />
							{{ $t('rtr_personal-asset-sale.text7') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Sale',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
